module.exports = __webpack_public_path__ + "assets/media/avtar.3e19d763.svg";